import React, {useEffect, useState} from 'react';
import {Template} from "../../../../../components/template/template.jsx";
import {Card} from "../../../../../components/card/card.jsx";
import InputForm from "../../../../../components/input/input-form.jsx";
import Button from "../../../../../components/button/button.jsx";
import {useParams} from "react-router";
import {toast} from "react-toastify";
import projectUtils from "../../../../../utils/project-utils.js";
import {navigateHook} from "../../../../../hooks/use-navigate.js";
import {useQuery} from "@tanstack/react-query";
import {FaPlus} from "react-icons/fa";
import Groups from "./components/groups/groups.jsx";
import Responsible from "./components/responsible/responsible.jsx";
import materialStorageService from "../../../../../services/web/material-storage-service.js";

const MaterialStorageForm = () => {
    const navigate = navigateHook();
    const {id} = useParams()
    const [isLoading, setIsLoading] = useState(false)
    const [description, setDescription] = useState("")
    const [groups, setGroups] = useState([])
    const [responsible, setResponsible] = useState([])

    const {data: storage, refetch, status} = useQuery({
        queryKey: ['material-storage', {id}], queryFn: () => materialStorageService.getById(id), enabled: !!id
    });

    useEffect(() => {
        if (status === "success") {
            setDescription(storage.description)
            setResponsible(JSON.parse(storage.responsibles))
            setGroups(JSON.parse(storage.material_groups))
        }
    }, [storage, status]);

    const saveAdd = () => save(true)

    const save = (saveAdd) => {
        setIsLoading(true);

        const formData = new FormData()
        formData.append("description", description)
        for (let i = 0; i < groups.length; i++) formData.append('material_groups[]', groups[i].id);
        for (let i = 0; i < responsible.length; i++) formData.append('responsibles[]', responsible[i].id);

        materialStorageService.save(formData, id)
            .then(({data}) => {
                projectUtils.success(!id || saveAdd);

                if (saveAdd) {
                    setDescription("")
                    setResponsible([])
                    setGroups([])
                    navigate("/materials/storages/form");
                    return;
                }

                if (id) {
                    refetch()
                    return;
                }

                const urlDev = `/materials/storages/form/${data.id}`;
                navigate(urlDev);

            })
            .catch((error) => {
                console.error(error);
                let message = 'Não foi possível salvar.';
                if (error.response.status !== 500) {
                    message = error.response.data.message;
                }

                projectUtils.swalErrorMessage('', message, 'Ok');
            })
            .finally(() => setIsLoading(false))
    }

    const openForm = () => {
        const urlDev = `/materials/storages/form`;
        navigate(urlDev)
    }

    return (<Template isLoading={isLoading}>
        <Template.Header>
            <Template.Title>
                Depósito
            </Template.Title>
            {
                id &&
                <Button target={"primary-outline"} onClick={openForm}>
                    <FaPlus/><span className="font-bold">Adicionar depósito</span>
                </Button>
            }
        </Template.Header>
        <Template.Body>

            <Card>
                <Card.Body>
                    <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-12">
                            <InputForm
                                id="description"
                                name={"description"}
                                value={description}
                                label="Descrição *"
                                onChange={({target: {value}}) => setDescription(value)}
                            />
                        </div>
                    </div>
                </Card.Body>
            </Card>

            <div className="grid grid-cols-12 gap-4 mt-2">
                <div className="col-span-6">
                    <Groups groups={groups} setGroups={setGroups}/>
                </div>
                <div className="col-span-6">
                    <Responsible responsible={responsible} setResponsible={setResponsible}/>
                </div>
            </div>

            <Card className={"mt-2"}>
                <Card.Body>
                    <div className="flex justify-end gap-2 w-full">
                        {!id &&
                            <Button target={"primary-outline"} onClick={saveAdd} actionFeedbackType='save'>Salvar e adicionar novo</Button>}
                        <Button onClick={() => save(false)} actionFeedbackType='save'>Salvar</Button>
                    </div>
                </Card.Body>
            </Card>
        </Template.Body>
    </Template>);
};

export default MaterialStorageForm;